export default "__VITE_ASSET__021fe038__"